import { TextInput } from "@mantine/core";
import React from "react";
import { withTranslation } from "react-i18next";



const InputField = ({
  label,
  value,
  disabled,
  width = "100%",
  icon,
  type = "text",
  placeholder,
 
  onChange,
  autoComplete = "off",
  form,
  validateName,
  required,
  onBlur,
  onInput,
  border = "1px solid #e0e0e0"
}) => {
  return (
   
      <TextInput
        label={label}
        onChange={onChange}
        onInput={onInput}
        type={type}
        defaultValue={value}
        onBlur={onBlur}
        disabled={disabled}
        autoComplete={autoComplete}
        required={required}
        placeholder={placeholder}
        
        {...form?.getInputProps(validateName)}
       styles={{
        input: {
          width: width,
          border: border,
        }
       }}
      />
  
  );
};

export default withTranslation()(InputField);
